import { useStore } from "@nanostores/preact";
import { logout } from "../net/api";
import { $roomPhase, $roomRequest } from "../room/phase";
import { $mailSummary } from "../state/mail";
import { $leaveRequest, $panel, $presence, $session } from "../state/stores";
import { AgentPromptButton } from "./AgentPromptButton";
import { CompassSection } from "./CompassSection";
import { Panel } from "./Panel";
import { $touchMode } from "../state/touch";
import { isIOS, isStandalone } from "../hud/touch/fullscreen";

export function MenuPanel() {
  const me = useStore($session);
  const presence = useStore($presence);
  const mail = useStore($mailSummary);
  const phase = useStore($roomPhase);
  const touch = useStore($touchMode);
  return (
    <Panel title="選單" onClose={() => $panel.set(null)}>
      <p class="hint">{me?.display_name}（{me?.email}）</p>
      {touch && isIOS() && !isStandalone() && <p class="hint">分享 → 加入主畫面，就能滿版遊玩</p>}
      {presence && (
        <button class="secondary" onClick={() => { $leaveRequest.set($leaveRequest.get() + 1); $panel.set(null); }}>
          離開領地（{presence.name}）
        </button>
      )}
      <button onClick={() => { $panel.set(null); $roomRequest.set($roomRequest.get() + 1); }}>{phase === "lobby" ? "回房間" : "回大廳"}</button>
      <button onClick={() => $panel.set("upload")}>上傳 GLB</button>
      <button onClick={() => $panel.set("inventory")}>我的資產</button>
      <button onClick={() => $panel.set("public")}>公開資產</button>
      <button onClick={() => $panel.set("plot")}>領地</button>
      <button onClick={() => $panel.set("mail")}>{mail && mail.unread_total > 0 ? `信箱（${mail.unread_total}）` : "信箱"}</button>
      <button onClick={() => $panel.set("settings")}>設定</button>
      <CompassSection />
      <AgentPromptButton />
      <button class="secondary" onClick={() => { location.href = "/account/"; }}>我的 agent</button>
      {me?.is_admin && <button class="secondary" onClick={() => { location.href = "/admin/"; }}>管理</button>}
      <button class="secondary" onClick={() => void logout().then(() => location.reload())}>登出</button>
      <p class="hint">{touch
        ? "房間：點 🏠 回到自己的房間，架上是你和 agent 上傳的模型；對著模型點「檢查」看動作，再點 🏠 回大廳。"
        : "房間：按 R 回到自己的房間，架上是你和 agent 上傳的模型；對著模型按 E 檢查動作，再按 R 回大廳。"}</p>
      <p class="hint">{touch
        ? "聊天：點 💬 打開，「頻道」切換頻道（附近 → 你所在或你的領地 → 全域），鍵盤的傳送鍵送出，✕ 取消。上次用的頻道會記住；全域每 3 秒一則。"
        : "聊天：按 T 打開，Tab 切換頻道（附近 → 你所在或你的領地 → 全域），Enter 送出，Esc 取消。上次用的頻道會記住；全域每 3 秒一則。"}</p>
      <p class="hint">{touch ? "信箱：點 ✉ 寫信給你的 agent，面板上方可複製排程提示詞。" : "信箱：按 M 寫信給你的 agent，面板上方可複製排程提示詞。"}</p>
      <p class="hint">碰撞：擺放的物件預設是固體，可以站上去；擺放時可選「可穿越」。</p>
      <p class="hint">卡住時：左上角第二行是領地座標，抄給 agent，或對準卡住的地方射一根 agent 標記。</p>
      <p class="hint">{touch ? "完整操作見設定" : "完整按鍵見設定"}</p>
    </Panel>
  );
}
